import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, CardImg } from 'reactstrap'
import Brand from '../../../images/brand.png'
import { withUserStore } from '../../contexts/UserStore'

const Header = ({ userStore }) => {
  const navigate = useNavigate()
  const [user, setUser] = useState()
  useEffect(() => {
    setUser(userStore.user)
  }, [userStore.user])

  const loginOrGoToApp = () => {
    if (user) {
      return (
        <span className="float-right margin-top-0-5">
          <Button
            onClick={() => navigate('/app')} size="sm" outline
            color="info"
          >Go To App
          </Button>
        </span>
      )
    } else {
      return (
        <span className="float-right margin-top-0-5">
          <Button
            onClick={() => navigate('/signup')} className="margin-right" size="sm"
            color="success"
          >Try Now!
          </Button>
          <Button
            onClick={() => navigate('/login')} size="sm" outline
            color="info"
          >Log In
          </Button>
        </span>
      )
    }
  }

  //        <h2><span className="size-75"> Do What Matters</span></h2>
  return (
    <div className="sticky-top page-header container distribute-span">
      <span className="logo margin-left-0">
        <span
          className="times-new-roman mouse-pointer padding-5 round5px"
          onClick={() => navigate('/')}
        >
          <span>
            <h2 className="margin0">
              <CardImg src={Brand} className="width35 margin-right-3px" />rioritize.Plus
            </h2>
          </span>
        </span>
      </span>
      <span className="spans">
        <span>
          <span>
            <span
              className="text-center mouse-pointer"
              onClick={() => navigate('/features')}
            >
              Features
            </span>
          </span>
          <span>
            <span className="text-center mouse-pointer" onClick={() => navigate('/demo')}>
              Demo
            </span>
          </span>
          <span>
            <span className="text-center mouse-pointer" onClick={() => navigate('/pricing')}>
              Pricing
            </span>
          </span>
        </span>
      </span>
      {loginOrGoToApp()}
    </div>

  )
}

export default withUserStore(Header)
